module.exports = __webpack_public_path__ + "img/qrcode.01abf621.png";